export default __webpack_public_path__ + "static/media/VictorLi.8032ded4.JPG";